/** 勋章排行榜 - 关前面板标志 */
const Event = require("cocos/framework/components/event")
var MedalRankSign = xClass("MedalRankSign", Event, function () {
    return cc.CSLoader.createNode("cocos/start_start_medal.csb");
})

MedalRankSign.prototype.ctor = function (data, startPanel) {
    let self = this;
    self.bind(self);
    self.initUI(data, startPanel);
}

MedalRankSign.prototype.initUI = function (data, startPanel) {
    let self = this;
    let start_medal_rank1 = self.getChildByName("start_medal_rank1");
    let num = self.getChildByName("label");
    let label_num = self.getChildByName("label_num");
    num.setNextFontPositionXOffset(-8);
    label_num.setNextFontPositionXOffset(-8);
    //
    quickBuildUIButtonNoAction(self, () => {
        if (self.isBusy) return;
        self.isBusy = true;
        data.type = "stage_start";
        let session = null;
        if (startPanel && startPanel.params) {
            session = startPanel.params.session;
            //
            let params = startPanel.params;
            params.click_type = "rank_icon";
            DCAssist.userTrack("stage", "stage_start_rank_click", params);
        }
        data.session = session;
        MedalRankManager.getInstance().openStartPanel(data, () => {
            self.isBusy = false;
        })
    })
    //
    label_num.setString("x" + data.count);
    num.setString("" + data.rank);
}


module.exports = MedalRankSign;